import React from 'react'
import PropTypes from 'prop-types'
import { ButtonStyled, Inner, IconWrapper } from './style'

const Button = ({
  as,
  children,
  className,
  fullWidth,
  href,
  icon,
  onClick,
  target,
  rel,
  to,
  type,
}) => {
  return (
    <ButtonStyled
      as={as}
      className={className}
      fullWidth={fullWidth}
      href={href}
      icon={icon}
      onClick={onClick}
      rel={rel}
      target={target}
      to={to}
      type={type}
    >
      <Inner icon={icon}>
        {children}
        {icon && <IconWrapper>{icon && icon}</IconWrapper>}
      </Inner>
    </ButtonStyled>
  )
}

Button.propTypes = {
  canLoad: PropTypes.bool,
  /** Text that will appear in the button */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Function called when button is clicked */
  onClick: PropTypes.func,
  /** Sets the styling to outline with transparent background */
  icon: PropTypes.node,
  /** If true will add display: inline-block to the button */
  type: PropTypes.string,
  /** Sets the button to fullWidth */
  fullWidth: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
  ]),
}

Button.defaultProps = {
  fullWidth: null,
  icon: null,
  type: 'button',
}

export default Button
